import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Navbar from './FitnessComponents/Navbar';
import Carousel from './FitnessComponents/Carousel';
import About from './FitnessComponents/About';
import Fitnessgoal from './FitnessComponents/Fitnessgoal';
import Feature from './FitnessComponents/Feature';
import Courses from './FitnessComponents/Courses';
import Blog from './FitnessComponents/Blog';
import Explore from './FitnessComponents/Explore';
import Team from './FitnessComponents/Team';
import Testimonial from './FitnessComponents/Testimonial';
import Footer from './FitnessComponents/Footer';
import Copyright from './FitnessComponents/Copyright';
import Aboutbanner from "./FitnessComponents/Aboutbanner";
import Coursesbanner from "./FitnessComponents/Coursesbanner";
import Blogbanner from "./FitnessComponents/Blogbanner";
import Featurebanner from "./FitnessComponents/Featurebanner";
import Ourteambanner from "./FitnessComponents/Ourteambanner";
import Testimonialbanner from "./FitnessComponents/Testimonialbanner";
import Contactbanner from "./FitnessComponents/Contactbanner";
import Contact from "./FitnessComponents/Contact";
import LegalInformation from "./FitnessComponents/Legalinfo";

function App() {
  return (
    <div className="App">
      {/* Google Web Fonts */}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      <link href="https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&family=Teko:wght@300..700&display=swap" rel="stylesheet" />
      
      {/* Icon Font Stylesheet */}
      <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.15.4/css/all.css" />
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-icons@1.4.1/font/bootstrap-icons.css" rel="stylesheet" />
      
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<><Carousel /><About /><Fitnessgoal /><Feature /><Courses /><Blog /><Explore /><Team /><Testimonial /></>} />
          <Route path="/about" element={<><Aboutbanner /><About /><Fitnessgoal /><Feature /><Explore /><Team /></>} />
          <Route path="/course" element={<><Coursesbanner /><br /><br /><Fitnessgoal /><br /><br /><Courses /><br /><br /><Testimonial /></>} />
          <Route path="/blog" element={<><Blogbanner /><Blog /></>} />
          <Route path="/feature" element={<><Featurebanner /><Feature /></>} />
          <Route path="/team" element={<><Ourteambanner /><Team /></>} />
          <Route path="/testimonial" element={<><Testimonialbanner /><Testimonial /></>} />
          <Route path="/contact" element={<><Contactbanner /><Contact /></>} />
          <Route path="/legal" element={<><Contactbanner /><LegalInformation /></>} />
        </Routes>
        <Footer />
        <Copyright />
      </Router>
    </div>
  );
}

export default App;
